import { withPlugins, domEvents, device } from '@spon/plugins';
import Headroom from 'headroom.js';
import toggle from '@/ui/toggle';

function Header({ node, name, plugins: { addEvents } }) {
	if (!node) return;
	/*
	 *		Variables
	 */

	// Headroom
	const options = {
		offset: node.clientHeight * 1.25 || 0,
		tolerance: {
			up: 5,
			down: 0,
		},
	};

	const headroom = new Headroom(node, options);

	let windowTop = 0;
	const lock = {
		capture() {
			windowTop = window.scrollY;
			document.body.style.position = 'fixed';
			document.body.style.top = `${windowTop * -1}px`;
			document.body.style.overflow = 'hidden';
			document.body.style.width = '100vw';

			headroom.freeze();
		},
		release() {
			document.body.style.position = '';
			document.body.style.top = '';
			document.body.style.overflow = '';
			document.body.style.width = '';
			if (windowTop) window.scroll(0, windowTop);

			window.setTimeout(() => headroom.unfreeze(), 1);
		},
	};

	const nav = toggle({
		button: node.querySelector('.burger'),
		name,
		activeClass: 'is-active',
	});

	/*
	 *		Functions
	 */

	function clickWhenOpenHandle({ target }) {
		if (target.id === 'header' || target.closest('#header')) return; // Continue if clicking within #Header
		nav.close();
	}

	nav.on(`open:${name}`, ({ target }) => {
		node.classList.add('nav-open');
		target.classList.add('is-open');

		lock.capture();

		document.addEventListener('click', clickWhenOpenHandle);
	});

	nav.on(`close:${name}`, ({ target }) => {
		node.classList.remove('nav-open');
		target.classList.remove('is-open');

		lock.release();

		document.removeEventListener('click', clickWhenOpenHandle);
	});

	function onKeyDown(event) {
		const { key } = event;
		if (key === 'Escape') {
			if (nav.isOpen) {
				nav.close();
			}
		}
	}

	/*
	 *		Init
	 */
	nav.init();
	headroom.init();

	/*
	 *		Events
	 */
	addEvents(document.body, {
		click: ({ target }) => {
			if (target.id === 'header' || target.closest('#header')) return;
		},
		keydown: onKeyDown,
	});

	return () => {};
}

export default withPlugins(domEvents, device)(Header);
